export enum OutboundShipmentSource {
  Api = "api",
  FulfillmentGroups = "fulfillment-groups",
}
